<div class="component-heading flex flex-row justify-start items-center">Conversations</div>

<!-- ITP-E-177-01 — live support requests nobody has answered yet; the first Answer wins. -->
<div class="live-requests" *ngIf="liveRequests.length || answered">
  <div class="live-requests__heading">Live support requests</div>
  <div class="live-request" *ngFor="let request of liveRequests" [attr.data-session-id]="request.sessionId"
       [class.live-request--taken]="taken[request.sessionId]">
    <div class="live-request__text">
      <div class="live-request__title">{{ request.title }}</div>
      <div class="live-request__meta">
        {{ request.ticketDisplayId }} · {{ request.requesterName }} · waiting {{ waitingFor(request) }}<span
          class="live-request__reconnect" *ngIf="request.isReconnect"> · reconnect request</span>
      </div>
      <!-- ITP-E-233-06: the client asked from inside a demo. -->
      <div class="live-request__demo" *ngIf="request.demoContext?.isDemo">
        <span class="live-request__demo-chip" [attr.title]="demoTooltip(request)" data-demo-chip>Raised from a demo</span>
      </div>
      <div class="live-request__error" *ngIf="answerErrors[request.sessionId]">{{ answerErrors[request.sessionId] }}</div>
    </div>
    <button type="button" class="live-request__answer" [disabled]="!canAnswer(request)"
            [attr.title]="answerHint(request) || null" (click)="answer(request)">Answer</button>
  </div>
  <div class="live-request__chat" *ngIf="answered">
    <div class="live-request__title">{{ answered.ticketDisplayId }} · {{ answered.requesterName }}
      <button type="button" class="live-request__answer" *ngIf="inLiveChat" [disabled]="disconnecting"
              (click)="disconnectAnswered()">Disconnect</button>
    </div>
    <app-xat-bot-live-support-chat [sessionId]="answered.sessionId" [myEmail]="myEmail"
                                   (sessionChange)="onAnsweredChange($event)"></app-xat-bot-live-support-chat>
  </div>
</div>
<div class="component-heading flex flex-row justify-between items-center">
  <a class="link-color"
     particleAnalytics
     analyticsCategory="conversation-list"
     analyticsAction="edit-btn">TBD</a>
</div>

<div class="rest-of simple-scroll">
  <div *ngFor="let conversation of conversationList"
       (click)="navigateToConversation(conversation)">
    <div *ngIf="conversation.titleAvatarInfo || conversation.isGroupConversation"
         class="conversation-container flex flex-row">

      <collaboration-avatar [gravatarInfo]="conversation.titleAvatarInfo"
                            [showGroupAvatar]="conversation.isGroupConversation"></collaboration-avatar>

      <div class="flex flex-col full-grow-no-shrink-no-basis" style="width: calc(100% - 50px)">
        <div class="flex flex-row justify-between items-center">
          <span class="user-name full-grow-no-shrink-no-basis">{{conversation?.title}}</span>
          <span class="timing">{{conversation.messages[conversation.messages.length - 1]?.createdDate | timeAgo}}</span>
        </div>
        <div class="description-container">
          <div
            class="description full-grow-no-shrink-no-basis">{{conversation.messages[conversation.messages.length - 1]?.message}}</div>
          <i [hidden]="conversation.unreadMessageCount>0? true:false" class="far fa-check"></i>
          <span [class]="conversation.unreadMessageCount>0?  'showBlock': 'hideBlock'"
                class="flex flex-row justify-center items-center"
          >
        {{conversation.unreadMessageCount}}
      </span>
        </div>
      </div>
    </div>

  </div>

</div>
<!--
-->
